import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';

export default function CancelableAlert({
  open,
  handleClose,
  content,
  title,
}: {
  open: boolean;
  handleClose: () => void;
  content: string | null | undefined;
  title: string | null | undefined;
}) {
  if (!open || !content || !title) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Continue</Button>
      </DialogActions>
    </Dialog>
  );
}
